/**
 * LIFF ID Configuration
 * Centralized configuration for all LINE LIFF IDs used in the application
 */

// Game page LIFF IDs
export const GAME_LIFF_IDS = {
  default: '1653890612-TUHx9P6v',
  relateds: '1653890612-TUHx9P6v',
  exhibits: '1653890612-CYfoLuRO',
  souls: '1653890612-fz4t6jRy',
  times: '1653890612-0GHjYBeu',
  hints: '1653890612-uXXQN4SV',
  shop: '1653890612-LQuIo0qo',
  yama: '1653890612-svy09nRl',
  records: '1653890612-gCcbti9q'
};

// Menu LIFF ID
export const MENU_LIFF_ID = '1653890612-IgueNAUr';

// Shop LIFF IDs
export const SHOP_LIFF_IDS = {
  tools: '1653890612-QWniLETD',
  stories: '1653890612-fspcHfGV'
};

// Payment/Purchase LIFF ID
export const PAYMENT_LIFF_ID = '1653890612-TCWhLcic';

// Profile LIFF ID
export const PROFILE_LIFF_ID = '1653890612-MJRE9XfB';

// Case Storage LIFF ID
export const CASE_STORAGE_LIFF_ID = '1653890612-J3Abo3HC';

// Tools page LIFF ID
export const TOOLS_LIFF_ID = '1653890612-hjQn59Ht';

// Scratch card/Activity LIFF ID
export const SCRATCH_CARD_LIFF_ID = '1653890612-PxSAb0MY';

/**
 * Get LIFF ID for game pages
 * @param {string} type - Game page type (relateds, exhibits, souls, etc.)
 * @returns {string} LIFF ID
 */
export const getGameLiffId = (type) => {
  return GAME_LIFF_IDS[type] || GAME_LIFF_IDS.default;
};

/**
 * Build LIFF URL
 * @param {string} liffId - LIFF ID
 * @param {Object} params - Query parameters
 * @returns {string} Full LIFF URL
 */
export const buildLiffUrl = (liffId, params = {}) => {
  const baseUrl = `https://liff.line.me/${liffId}`;
  const queryString = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

/**
 * Build LINE app URL (line://app/...)
 * @param {string} liffId - LIFF ID
 * @param {Object} params - Query parameters
 * @returns {string} LINE app URL
 */
export const buildLineAppUrl = (liffId, params = {}) => {
  const baseUrl = `line://app/${liffId}`;
  const queryString = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export default {
  GAME_LIFF_IDS,
  MENU_LIFF_ID,
  SHOP_LIFF_IDS,
  PAYMENT_LIFF_ID,
  PROFILE_LIFF_ID,
  CASE_STORAGE_LIFF_ID,
  TOOLS_LIFF_ID,
  SCRATCH_CARD_LIFF_ID,
  getGameLiffId,
  buildLiffUrl,
  buildLineAppUrl
};
